
import { defineComponent, ref } from 'vue';
import ExecutionTable from '@/components/ExecutionTable.vue';
// import store from '@/store';

export default defineComponent({
  name: 'About',
  components: { ExecutionTable },
  setup() {
    const rows = ref([
      {
        id: 1,
        name: 'Chandler Bing',
        phone: '305-917-1301',
        profession: 'IT Manager',
        registrationDate: '01-01-2020',
        createdDate: '01-01-2020',
      },
      {
        id: 2,
        name: 'Ross Geller',
        phone: '210-684-8953',
        profession: 'Paleontologist',
        registrationDate: '01-01-2020',
        createdDate: '01-01-2020',
      },
      {
        id: 3,
        name: 'Rachel Green',
        phone: '765-338-0312',
        profession: 'Waitress',
        registrationDate: '01-01-2020',
        createdDate: '01-01-2020',
      },
      {
        id: 4,
        name: 'Monica Geller',
        phone: '714-541-3336',
        profession: 'Head Chef',
        registrationDate: '01-01-2020',
        createdDate: '01-01-2020',
      },
      {
        id: 5,
        name: 'Joey Tribbiani',
        phone: '972-297-6037',
        profession: 'Actor',
        registrationDate: '01-01-2020',
        createdDate: '01-01-2020',
      },
      {
        id: 6,
        name: 'Phoebe Buffay',
        phone: '760-318-8376',
        profession: 'Masseuse',
        registrationDate: '01-01-2020',
        createdDate: '01-01-2020',
      },
      {
        id: 7,
        name: 'Chandler Bing',
        phone: '305-917-1301',
        profession: 'IT Manager',
        registrationDate: '01-01-2020',
        createdDate: '01-01-2020',
      },
      {
        id: 8,
        name: 'Ross Geller',
        phone: '210-684-8953',
        profession: 'Paleontologist',
        registrationDate: '01-01-2020',
        createdDate: '01-01-2020',
      },
      {
        id: 9,
        name: 'Rachel Green',
        phone: '765-338-0312',
        profession: 'Waitress',
        registrationDate: '01-01-2020',
        createdDate: '01-01-2020',
      },
      {
        id: 10,
        name: 'Monica Geller',
        phone: '714-541-3336',
        profession: 'Head Chef',
        registrationDate: '01-01-2020',
        createdDate: '01-01-2020',
      },
      {
        id: 11,
        name: 'Joey Tribbiani',
        phone: '972-297-6037',
        profession: 'Actor',
        registrationDate: '01-01-2020',
        createdDate: '01-01-2020',
      },
      {
        id: 12,
        name: 'Phoebe Buffay',
        phone: '760-318-8376',
        profession: 'Masseuse',
        registrationDate: '01-01-2020',
        createdDate: '01-01-2020',
      },
    ]);
    const columns = ref([
      {
        field: 'id',
        text: 'Id',
        datatype: 'number',
        showToggle: false,
        value: '',
        visible: true,
      },
      {
        field: 'name',
        text: 'Name',
        datatype: 'string',
        showToggle: false,
        value: '',
        visible: true,
      },
      {
        field: 'phone',
        text: 'Phone',
        datatype: 'string',
        showToggle: false,
        value: '',
        visible: true,
      },
      {
        field: 'profession',
        text: 'Profession',
        datatype: 'string',
        showToggle: false,
        value: '',
        visible: true,
      },
      {
        field: 'createdDate',
        text: 'Created Date',
        datatype: 'datetime-local',
        showToggle: false,
        value: { from: '', to: '' },
      },
      { field: 'registrationDate', text: 'Registration Date', datatype: 'date', showToggle: false, value: { from: '', to: '' } },
    ]);
    // const sortColumn = ref('');
    console.log('inside About');
    // const sortTable = (col) => {
    //   if (sortColumn.value === col) {
    //     ascending.value = !ascending.value;
    //   } else {
    //     ascending.value = true;
    //     sortColumn.value = col;
    //   }
    //   const ascend = ascending.value;
    //   rows.value.sort((a, b) => {
    //     if (a[col] > b[col]) {
    //       return ascend ? 1 : -1;
    //     }
    //     if (a[col] < b[col]) {
    //       return ascend ? -1 : 1;
    //     }
    //     return 0;
    //   });
    // };
    // store.dispatch('landing/getSystemUnderMaintenance');
    // const welcomeMsg = computed(() => store.getters['landing/welcomeMessage']);
    return { rows, columns };
  },
});
